import { render, staticRenderFns } from "./PersonalProfile.vue?vue&type=template&id=b4d01b60&"
import script from "./PersonalProfile.vue?vue&type=script&lang=js&"
export * from "./PersonalProfile.vue?vue&type=script&lang=js&"
import style0 from "./PersonalProfile.vue?vue&type=style&index=0&id=b4d01b60&prod&lang=scss&"
import style1 from "./PersonalProfile.vue?vue&type=style&index=1&id=b4d01b60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports